import { logger } from '../../../utils/logger';
import { getVoiceService } from '../call-control';
import { resolveOutboundSkillId } from './outbound-skill-resolver';

export async function makeOutboundCall(phoneNumber: string, skillId?: number): Promise<void> {
  logger.debug('[CXone SDK] Making outbound call to:', phoneNumber);

  let effectiveSkillId = skillId ?? 0;
  if (effectiveSkillId === 0) {
    const foundSkillId = await resolveOutboundSkillId();
    if (foundSkillId) {
      effectiveSkillId = foundSkillId;
    }
  }

  logger.debug('[CXone SDK] Using skill ID:', effectiveSkillId);

  const service = getVoiceService();
  const response = await service.dialPhone({
    phoneNumber,
    skillId: effectiveSkillId,
  });

  logger.debug('[CXone SDK] dialPhone response:', response);
}
